import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-administration-confirm-action-dialog',
	templateUrl: './confirm-action-dialog.component.html',
	styleUrls: ['./confirm-action-dialog.component.scss']
})
export class ConfirmActionDialogComponent implements OnInit {
	text: string;
	translateContext: TranslateContext = TranslateContext.ADMINISTRATION;

	constructor(@Inject(MAT_DIALOG_DATA) private data,
				private dialogRef: MatDialogRef<ConfirmActionDialogComponent>
	) {
		this.text = this.data.text;
	}

	ngOnInit() {
	}

	confirmAction(confirm) {
		this.dialogRef.close(confirm);
	}

}
